import React, { useRef, useState } from 'react';
import RemoveItemButton from '../../../../../../../components/RemoveItemButton/Facelift';
import {
  Container,
  PavementColumn,
  ArrowsContainer,
  PavementStatus,
  PavementFloor,
  PavementTitle,
  ConcretingAndOrdersContainer
} from './styles';
import pillars from '../../../../../../../assets/images/fabrication_mockup/pillars.png';
import slab from '../../../../../../../assets/images/fabrication_mockup/slab.png';
import beam from '../../../../../../../assets/images/fabrication_mockup/beam.png';
import { IPavement } from '../../../../../../../store/ducks/fabrication-mockups/types';
import moment from 'moment';
import Concreting from './Concreting';
import PavementProjectsTable from './ViewPavementProjectsTable';
import PavementOrders from './PavementOrders';
import { Button } from '@gerdau/hefesto/Button';
import { TextField } from '@gerdau/hefesto/TextField';
import { Tooltip } from '@gerdau/hefesto/Tooltip';
import { Icon } from '@gerdau/hefesto/Icon';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getTaggingInformationScreen } from '../../../../../../../utils/Tagging';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { IPavementStatusProps } from '../../PavementStatus';
import { ERoutes } from '../../../../../../../routes';
import { EProjectsMockupsRoutes } from '../../../../../projectsMockup.routes';
import { IPavementOrdersProps } from '../../PavementOrders';
import { EMockupViewRoutes } from '../../mockupView.routes';

interface IPavementsItemProps {
  index: number;
  mockupId: number;
  pavement: IPavement;
  contractNumber: string;
  listOfPavementNames: string[];
  onEditClick: (id?: number) => void;
  onSavePavement: (pavement: IPavement) => void;
  onRemovePavement: () => void;
  editingIdx?: number;
  onChangePosition: (newPosition: number) => void;
  totalPavementsAboveGround: number;
  totalPavementsBelowGround: number;
  newestAddedPavementId?: string;
  cleanNewestAddedPavementId: () => void;
  isSaving: boolean;
  abovePavementHasOrders: boolean;
  belowPavementHasOrders: boolean;
}

const PavementItem: React.FC<IPavementsItemProps> = ({
  index,
  mockupId,
  pavement,
  contractNumber,
  listOfPavementNames,
  onEditClick,
  onSavePavement,
  onRemovePavement,
  editingIdx,
  onChangePosition,
  totalPavementsAboveGround,
  totalPavementsBelowGround,
  newestAddedPavementId,
  cleanNewestAddedPavementId,
  isSaving,
  abovePavementHasOrders,
  belowPavementHasOrders
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const isEditingCurrentPavement = index === editingIdx;
  const [pavementName, setPavementName] = useState('');

  const [canShowPavementProjectsModal, setCanShowPavementProjectsModal] =
    useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const hasOrders = !!pavement.orders?.length;

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    pathname,
    true
  );

  const getPavementsContainerClassname = () => {
    const classList = [];
    if (pavement.position === -1) {
      classList.push('first-floor-below-ground');
    }

    if (!!newestAddedPavementId && newestAddedPavementId === pavement.id) {
      classList.push('new-pavement');

      setTimeout(() => {
        cleanNewestAddedPavementId();
      }, 1500);
    }

    return classList.join(' ');
  };
  const pavementContainerClassName = getPavementsContainerClassname();

  const getPavementsStatusClassname = () => {
    if (pavement.position === -1) {
      return 'first-floor-below-ground';
    } else if (pavement.position === totalPavementsAboveGround - 1) {
      return 'roof-floor';
    }
  };
  const pavementStatusClassName = getPavementsStatusClassname();

  const onCancelEdit = () => {
    setPavementName(pavement.name);
    onEditClick();
  };

  const onRemoveConfirmClick = () => {
    if (pavement.position === 0) {
      return;
    } else {
      containerRef.current?.classList.add('remove-pavement');
      setTimeout(() => {
        containerRef.current?.classList.remove('remove-pavement');
        onRemovePavement();
      }, 1000);
    }
  };

  const isTheTopOfMockup = (): boolean => {
    return pavement.position === totalPavementsAboveGround - 1;
  };

  const isTheBottomOfMockup = (): boolean => {
    return (
      pavement.position <= 0 &&
      Math.abs(pavement.position) === totalPavementsBelowGround
    );
  };

  const goToProjectMockupView = () => {
    history.push(
      `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}${EMockupViewRoutes.PAVEMENT_PROJECTS}`,
      pavement
    );
  };

  return (
    <Container className={pavementContainerClassName} ref={containerRef}>
      {pavement.position === 0 && (
        <div className="ground-floor">
          <div className="ground-floor-line">
            <div className="line"></div>
            <div className="square"></div>
          </div>
          <span className="title">Linha da superfície</span>
        </div>
      )}
      <PavementColumn className={`pavement-column floor-container`}>
        <ArrowsContainer>
          <Button
            name="arrowsUp"
            onClick={() => onChangePosition(pavement.position + 1)}
            disabled={
              !!editingIdx ||
              isSaving ||
              isTheTopOfMockup() ||
              hasOrders ||
              abovePavementHasOrders
            }
            icon={<Icon option="CaretUp" variant="tertiary" />}
            variant="none"
          ></Button>
          <Button
            name="arrowsDown"
            onClick={() => onChangePosition(pavement.position - 1)}
            disabled={
              isTheBottomOfMockup() ||
              !!editingIdx ||
              isSaving ||
              hasOrders ||
              belowPavementHasOrders
            }
            icon={<Icon option="CaretDown" variant="tertiary" />}
            variant="none"
          ></Button>
        </ArrowsContainer>
        <PavementFloor>
          <div className="lines"></div>
          <img src={slab} alt={'imagem da laje parte de cima da caixa'} />
          <img src={beam} alt={'imagem da viga embaixo da laje'} />
          <div>
            <img
              src={pillars}
              alt={'imagem do pilar da esquerda embaixo da viga'}
            />
            {!isEditingCurrentPavement && (
              <div className="last-updated">
                <div className="projects-and-orders-buttons">
                  <div className="endpavement">
                    <PavementTitle>
                      <TextField
                        name="pavement-name"
                        label="Nome do pavimento"
                        value={pavement.name}
                        readOnly
                      />
                      <div className="actions">
                        <Tooltip
                          title={
                            hasOrders
                              ? 'Não é possível editar nome de pavimento que já está associado a um pedido.'
                              : 'Clique para renomear este pavimento.'
                          }
                        >
                          <Button
                            name="editButtonIcon"
                            onClick={() => {
                              onEditClick(index);
                              setPavementName(pavement.name);
                            }}
                            disabled={isSaving || hasOrders}
                            icon={<Icon option="Edit" variant="primary" />}
                            variant="none"
                          ></Button>
                        </Tooltip>

                        <RemoveItemButton
                          onRemoveItem={onRemoveConfirmClick}
                          disabled={
                            isSaving || hasOrders || pavement.position === 0
                          }
                          tooltipMessage={
                            hasOrders
                              ? 'Não é possível remover um pavimento que já está associado a um pedido.'
                              : 'Clique para remover este pavimento.'
                          }
                        />
                      </div>
                    </PavementTitle>
                  </div>

                  <span className="pavement-update">
                    Atualizado em:{' '}
                    {moment(pavement.updatedAt).format('DD/MM/YYYY') ||
                      '--/--/----'}
                  </span>
                  <div className="pavement-buttons">
                    <Button
                      name="projectsButton"
                      onClick={() => {
                        goToProjectMockupView();
                      }}
                      disabled={
                        (!!pavement.projects && pavement.projects.length < 1) ||
                        !pavement.projects
                      }
                      variant="secondary"
                    >
                      Ver projetos
                    </Button>
                    <Button
                      name="ordersButton"
                      onClick={() => {
                        history.push(
                          `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}${EMockupViewRoutes.PAVEMENT_ORDERS}`,
                          {
                            pavement,
                            contractNumber
                          } as IPavementOrdersProps
                        );
                      }}
                      disabled={
                        (!!pavement.orders && pavement.orders.length < 1) ||
                        !pavement.orders
                      }
                      variant="secondary"
                    >
                      Ver pedidos
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {isEditingCurrentPavement && (
              <PavementTitle className="editing">
                <Tooltip
                  title={'A maquete não pode ter pavimentos com o mesmo nome'}
                >
                  <TextField
                    name="pavementName"
                    label="Nome do pavimento"
                    value={pavementName}
                    onChange={(e) => setPavementName(e.target.value)}
                  />
                </Tooltip>
                <div className="actions">
                  <Tooltip title={'Cancelar'}>
                    <Button
                      name="cancelEdit"
                      onClick={onCancelEdit}
                      icon={<Icon option="X" variant="primary" />}
                      variant="none"
                    ></Button>
                  </Tooltip>
                  <Tooltip title={'Confirmar'}>
                    <Button
                      name="confirmEdit"
                      onClick={() => {
                        onSavePavement({ ...pavement, name: pavementName });
                      }}
                      disabled={listOfPavementNames.includes(pavementName)}
                      icon={<Icon option="Check" variant="primary" />}
                      variant="none"
                    ></Button>
                  </Tooltip>
                </div>
              </PavementTitle>
            )}
            <img
              src={pillars}
              alt={'imagem do pilar da direita embaixo da viga'}
            />
          </div>
        </PavementFloor>
      </PavementColumn>
      <PavementColumn className="pavement-column">
        <PavementStatus className={pavementStatusClassName}>
          <header className="pavement-status-header">
            <span className="pavement-status-name">{pavement.name}</span>
            <Button
              name="updateDate"
              onClick={() => {
                dispatch(
                  sendTagging({
                    screenName,
                    itemName: 'button:atualizar_datas',
                    itemDescription: `${itemDescription}_atualizarDatas`,
                    event: 'click'
                  })
                );
                history.push(
                  `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}${EMockupViewRoutes.PAVEMENT_STATUS}`,
                  {
                    pavement,
                    mockupId,
                    contractNumber
                  } as IPavementStatusProps
                );
              }}
              disabled={isSaving || pavement.isNewPavement}
              variant="secondary"
            >
              Atualizar datas
            </Button>
          </header>

          <ConcretingAndOrdersContainer>
            {!pavement.isNewPavement && (
              <>
                <Concreting pavement={pavement} />
                <PavementOrders orders={pavement.orders || []} />
              </>
            )}
            {pavement.isNewPavement && (
              <span className="save-mockup-alert">
                Para inserir dados de concretagem, clique em&nbsp;
                <a
                  href="!#"
                  onClick={(e) => {
                    e.preventDefault();
                    const btn = document.querySelector('.save-mockup-btn');
                    btn?.scrollIntoView({
                      block: 'center',
                      behavior: 'smooth'
                    });
                  }}
                >
                  Salvar edições
                </a>
                &nbsp; antes.
              </span>
            )}
          </ConcretingAndOrdersContainer>
        </PavementStatus>
      </PavementColumn>
      {canShowPavementProjectsModal && (
        <PavementProjectsTable
          contractNumber={contractNumber}
          pavement={pavement}
          onCancel={() => setCanShowPavementProjectsModal(false)}
        />
      )}
    </Container>
  );
};

export default PavementItem;
